import { useTranslation } from 'react-i18next';
import PaywallDescription from 'src/components/Paywall/PaywallDescription';
import { createCdnIcon } from 'src/designSystem/CdnIcon';
import logoMonkeyUrl from 'src/assets/onboarding/logo-monkey.svg';
import PanelHeader from 'src/designSystem/PanelHeader';
import { useCurrentUser } from 'src/queries/user';

const GameControllerIcon = createCdnIcon('paywall/game-controller.svg');
const ThumbUpIcon = createCdnIcon('paywall/thumb-up.svg');
const MagicWandIcon = createCdnIcon('paywall/magic-wand.svg');
const StarIcon = createCdnIcon('paywall/star.svg');
const SmileyIcon = createCdnIcon('paywall/smiley.svg');
import ChildPaywallScreenDescription from 'src/components/Paywall/PaywallScreenDescription.child';
import { isChildUser, isParentUser } from 'src/utils/userRole';

const PaywallScreenDescription = () => {
  const { data: user } = useCurrentUser();
  const isParent = isParentUser(user);
  const { t } = useTranslation();

  if (isChildUser(user)) {
    return <ChildPaywallScreenDescription />;
  }

  return (
    <>
      <PanelHeader
        illustration={<img src={logoMonkeyUrl} alt="" className="h-28 w-auto aspect-[49/48]" />}
        title={
          isParent
            ? t(`paywall.description.parent.subtitle`)
            : t(`paywall.description.child.subtitle`)
        }
      />

      <div className={'flex flex-col gap-4 items-start'}>
        <PaywallDescription
          title={
            isParent
              ? t(`paywall.description.parent.item1.title`)
              : t(`paywall.description.child.item1.title`)
          }
          description={
            isParent
              ? t(`paywall.description.parent.item1.description`)
              : t(`paywall.description.child.item1.description`)
          }
          IconComponent={
            isParent ? MagicWandIcon : ThumbUpIcon
          }
        />
        <PaywallDescription
          title={
            isParent
              ? t(`paywall.description.parent.item2.title`)
              : t(`paywall.description.child.item2.title`)
          }
          description={
            isParent
              ? t(`paywall.description.parent.item2.description`)
              : t(`paywall.description.child.item2.description`)
          }
          IconComponent={
            isParent ? ThumbUpIcon : GameControllerIcon
          }
        />
        <PaywallDescription
          title={
            isParent
              ? t(`paywall.description.parent.item3.title`)
              : t(`paywall.description.child.item3.title`)
          }
          description={
            isParent
              ? t(`paywall.description.parent.item3.description`)
              : t(`paywall.description.child.item3.description`)
          }
          IconComponent={isParent ? SmileyIcon : StarIcon}
        />
      </div>
    </>
  );
};

export default PaywallScreenDescription;
